/** @jsx jsx */
import { jsx } from '@emotion/core'
import * as _ from 'lodash'
import React, { Fragment, useMemo, useEffect } from 'react'
import { observer } from 'mobx-react'
import { Checkbox } from 'antd'
import styled from '@themes/theme'
import { MessageWrap, PointStyle } from '@views/Popup/BettorGiftContentPopup/index.style'
import { Point } from '@styles/base.style'
import { getCommunicationBlockTypeText, isCustomProfileImg } from '@utils/utils'
import useRootStore from '@store/useRootStore'
import { COMMUNICATION_BLOCK_TYPE } from '@v2/constants/common'
import { useOnMount } from '@utils/reactExt'
import AdvImg from '@components/AdvImg'

const AdvBlockWrap = styled.div`
  .block-contents {
    text-align: left;
    padding: 0 9px;
    margin-left: 15px;
    &-list {
      height: 35px;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      &:last-child {
        margin-bottom: 18px;
      }
    }
    .ant-checkbox-wrapper {
      > span {
        color: ${props => props.theme.color.modalSubTxt};
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.medium};
      }
      .ant-checkbox-inner, .ant-checkbox-checked::after {
        width: 18px;
        height: 18px;
        border-radius: 50%;
      }
      .ant-checkbox-checked .ant-checkbox-inner {
        background: ${props => props.theme.color.accordion2} !important;
        border-color: ${props => props.theme.color.accordion2} !important;
      }
    }
  }
`

interface AdvBlockListProps {
  userPromiseId: string
  userNick: string
  userProfileImg: string
}

export const AdvBlockList: React.FC<AdvBlockListProps> = observer((props) => {
  const { componentStore } = useRootStore()
  const { selectedUserCommunicationBlocks } = componentStore
  const { userPromiseId, userNick, userProfileImg } = props
  const isCustomProfile = isCustomProfileImg(userProfileImg)

  useOnMount(() => {
    componentStore.fetchUserCommunicationBlockInfo(userPromiseId).catch(console.error)
  })

  useEffect(() => {
    const advBlockListElem = document.querySelector(`.new-slide-type`)
    const disabledClassName = 'disabled'

    if (_.isEmpty(selectedUserCommunicationBlocks)) {
      advBlockListElem.classList.add(disabledClassName)
    } else {
      advBlockListElem.classList.remove(disabledClassName)
    }
  }, [selectedUserCommunicationBlocks])

  const onClickBlockCheck = (
    communicationBlockType: COMMUNICATION_BLOCK_TYPE
  ) => {
    const newCommunicationBlockInfos = _.cloneDeep(selectedUserCommunicationBlocks)
    const checked = _.includes(newCommunicationBlockInfos, communicationBlockType)

    if (checked) {
      _.remove(
        newCommunicationBlockInfos,
        (blockInfo) => blockInfo === communicationBlockType
      )
    } else {
      newCommunicationBlockInfos.push(communicationBlockType)
    }

    componentStore.setSelectedUserCommunicationBlocks(newCommunicationBlockInfos)
  }

  const contents = useMemo(() => {
    return (
      <ul className="block-contents">
        {
          _.chain(COMMUNICATION_BLOCK_TYPE)
            .filter((value) => _.isNumber(value))
            .map(communicationBlockType => {
              const checked = _.includes(selectedUserCommunicationBlocks, communicationBlockType)

              return (
                <li key={`block-contents-${communicationBlockType}`} className="block-contents-list">
                  <Checkbox defaultChecked={checked} checked={checked} onClick={() => {
                    onClickBlockCheck(communicationBlockType)
                  }}>
                    {getCommunicationBlockTypeText(communicationBlockType)}
                  </Checkbox>
                </li>
              )
            }).value()
        }
      </ul>
    )
  }, [selectedUserCommunicationBlocks])

  return (
    <AdvBlockWrap>
      <MessageWrap className="bettor-heart message-wrap">
        <Fragment key={userPromiseId}>
          <div className="bettor-profile-img-wrap lhn22">
            {isCustomProfile ?
              (<AdvImg src={userProfileImg} srcMode={'small'} alt="사진첩 프로필" className="profile-img custom-img"/>)
              :
              (<AdvImg src={userProfileImg} srcMode={'small'} alt="스킨 프로필" className="profile-img" />)
            }
          </div>
          <h3 className="tit">
            <Point css={PointStyle}>{userNick}</Point>님의
            <br/>
            다음 항목을 차단합니다.
          </h3>
        </Fragment>
      </MessageWrap>
      <span className="line"/>
      { contents }
    </AdvBlockWrap>
  )
})
